import { useQuery } from "@tanstack/react-query";

import { teamQuery } from "#modules/users/infra/team.query";

export const useTeam = () => {
  const { data, ...rest } = useQuery({ ...teamQuery() });

  return { team: data ?? [], ...rest };
};
